import util from '../util'

let controller = 'RepasseSaldoConta'
export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'put', 'persist']), {
    GetAll: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller, dto)
    },
    ObterCodigosContaDebito: function (id) {
        return util.Axios.Get(controller + '/ContasDebito', id)
    },
    ObterDadosRepasseExterno: function (id) {
        return util.Axios.Get(controller + '/DadosRepasseExterno', id)
    },
    ListarDetalhesProcessamento: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + '/DetalhesProcessamento', dto)
    }
})
